<template>
   <div class="function_wrap"   >
        <!-- style="!isPhone?'width:1250px;':'width:98%'  " -->
            <consult v-if="!isPhone"></consult>
       <!-- :class=" !isPhone? 'function_wrap box':'function_wrap box_mobile' "  -->
            <div :class=" !isPhone? 'function_wrap box':'function_wrap box_mobile' "  >
                <!-- <div class="function_wrap_title">LPR利息计算器</div> -->
                <h1 class="function_wrap_title">LPR利率计算器</h1>
                <div class="function_wrap_title_EN">LPR INTEREST CALCULATOR</div>
                
       
                <div class='optionitem' :style="isPhone?'width:100%':'' "  >   
                    <div class="optionitem item_name" >输入金额：</div>
                    <div class="optionitem item_detail"> <el-input type='number'   v-model="inputValue" placeholder="请输入金额"></el-input> </div>
                    
                </div>  


                <div class='optionitem'  :style="isPhone?'width:100%':'' " >   
                        <div class="optionitem item_name">起止日期：</div>
                        <!-- <div  class="optionitem item_detail" >
    
                            <el-date-picker
                                v-model="date"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd"
                                style=" width:100% ">
                            </el-date-picker>
                        </div> -->


                    <div  class="optionitem item_detail" style="margin-left:0" >
                        <el-date-picker
                            v-model="date[0]"
                            align="right"
                            type="date"
                            placeholder="选择日期"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                        <span :style="isPhone?'margin: 10px 10px ':'margin: 0 10px 0 10px' "  >至</span>
             

                        <el-date-picker
                            v-model="date[1]"
                            type="date"
                            placeholder="选择日期"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>


 


                    </div>
        
                </div>  



                <div class='optionitem'  :style="isPhone?'width:100%':'' " >   
                    <div class="optionitem item_name"  >计息方式：</div>
                    <div class="optionitem item_detail"   > 
                        <!-- <el-radio v-model="ishalf" label="1" border>否</el-radio>
                        <el-radio v-model="ishalf" label="2" border>是</el-radio> -->
                        <el-radio-group v-model="ratio"  >
                            <!-- <el-radio label="LPR" style="margin-bottom:10px">分段LPR</el-radio> -->

                            <el-tooltip  class="item" effect="dark" content="按照每个月的lpr利率动态计算" placement="top" >
                              
                                <el-radio label="LPR" style="margin-bottom:10px">分段LPR</el-radio>
                            </el-tooltip>


                            <el-radio label="avgLPR" style="margin-bottom:10px">平均LPR</el-radio>
                            <el-radio label="lastLPR" style="margin-bottom:10px">截至月LPR</el-radio>
                            <el-radio label="firstLPR" style="margin-bottom:10px">起始月LPR</el-radio>
                            <!-- <el-radio label="maxLPR" style="margin-bottom:10px">法定最高(x4)</el-radio> -->

                            <el-tooltip  class="item" effect="dark" content="司法认可的民间借贷利率上限，一般为四倍一年期lpr利率" placement="top" >
                                <!-- <div slot="content">多行信息<br/>第二行信息</div> -->
                                <el-radio label="maxLPR" style="margin-bottom:10px">法定最高(x4)</el-radio>
                            </el-tooltip>
                            <!-- <el-radio :label="'年息'">年息</el-radio> -->
                        </el-radio-group>  

                    </div>

                </div>  

                <div class='optionitem' :style="isPhone?'width:100%':'' " >   
                    <div class="optionitem item_name">自然年天数基准：</div>
                    <div class="optionitem item_detail"  > 
                        <!-- <el-radio v-model="ishalf" label="1" border>否</el-radio>
                        <el-radio v-model="ishalf" label="2" border>是</el-radio> -->
                        <el-radio-group v-model="day_base"  >
                            <el-radio label="360">360</el-radio>
                            <el-radio label="365">365</el-radio>
                        </el-radio-group>

                    </div>

                </div>   

                <div class='optionitem' :style="isPhone?'width:100%':'' " >   
                    <div class="optionitem item_name">天数算法：</div>
                    <div class="optionitem item_detail" > 
            
                        <el-radio v-model="days_mode"  :size="isPhone? 'mini':'' "  label="mode_d1" border style="margin:10px 40px">算头不算尾</el-radio>
                        <el-radio v-model="days_mode" :size="isPhone? 'mini':'' "  label="mode_d2" border style="margin:10px 40px">两头都算</el-radio>
                        
                   
                    </div>

                </div> 

                <div class='optionitem' :style="isPhone?'width:100%':'' " >   
                    <div class="optionitem item_name">利率模式：</div>
                    <div class="optionitem item_detail" > 
            
                        <el-radio v-model="lpr_mode"  :size="isPhone? 'mini':'' "  label="lpr1" border style="margin:10px 40px">一年期lpr利率</el-radio>
                        <el-radio v-model="lpr_mode" :size="isPhone? 'mini':'' "  label="lpr5" border style="margin:10px 40px">五年期lpr利率</el-radio>
                        
                   
                    </div>

                </div> 

                
                <div v-if="ratio!='maxLPR'" class='optionitem' :style="isPhone?'width:100%':'' " >   
                    <div class="optionitem item_name">浮动值：</div>
                    <div class="optionitem item_detail">
                    <el-input-number v-model="float_step" :step="0.1"></el-input-number>
                    <span style="margin-left:10px">%</span>
                    <span style="margin-left:10px;font-size:14px"> (当用户想使用浮动利率，可选择上调或下浮，单位百分比) </span>
                </div>
                <!-- <div class="optionitem item_detail" > 
        
                    <el-radio v-model="lpr_mode"  :size="isPhone? 'mini':'' "  label="lpr1" border style="margin:10px 40px">一年期lpr利率</el-radio>
                    <el-radio v-model="lpr_mode" :size="isPhone? 'mini':'' "  label="lpr5" border style="margin:10px 40px">五年期lpr利率</el-radio>
                    
                
                </div> -->

                </div> 




                <div class='optionitem'  v-if="ratio=='maxLPR'" :style="isPhone?'width:100%':'' " >   
                    <div class="optionitem item_name">取用时间：</div>
                    <div class="optionitem item_detail" > 
                        <el-radio v-model="max_mode"  :size="isPhone? 'mini':'' "  label="max1" border style="margin:10px 40px">取开始日期</el-radio>
                        <el-radio v-model="max_mode" :size="isPhone? 'mini':'' "  label="max2" border style="margin:10px 40px">取截止日期</el-radio>
                    </div>

                </div> 


                <div class="plus_box">
                    <div class='refund_box' style="justify-content:space-between; ">  
                        <div  >  
                            <el-badge value="hot"  style="right:-10px"  >
                                <!-- <el-button size="small">回复</el-button> -->
                                <span title='解决中间夹杂付款或还款的场景，计算更加简单' >期间付款或还款记录(会员功能 ）：</span>
                            </el-badge>

                        </div>
                      

                        <!-- <span style="width:85%">期间付款或还款记录(会员功能）：</span> -->
                        <div  style="display:flex;flex-direction:row;padding-right:10px" >
                            <div>    
                                <router-link  to="/community/enk91631296197" target='_blank'  class="guide">   
                                    使用说明
                                </router-link> 
                            </div>   
                           
                          <div> <i  class="el-icon-circle-plus" style="font-size:24px;cursor:pointer;margin-top:5px" @click="AddLine"></i>  </div>
                            
                        </div> 
                        
                             
                         
                    </div>

                    <div class='newline'   v-for="(item,index) of param.cond" v-bind:key="index">   
                        <div class="newline item_name" style="text-align:center">  还款日期: </div>
                        <!-- param.cond[index] -->
                        <el-date-picker
                            style="width:200px"
                            v-model="item.date"
                            align="right"
                            type="date"
                            placeholder="选择日期"
                            format='yyyy-MM-dd'
                            value-format='yyyy-MM-dd'
                            >
                        </el-date-picker>

                        <span  class="newline item_name"    style="text-align:center">还款金额：</span>
            

                        <el-input class="newline item_detail" type='number' min=0 v-model="item.amount" ></el-input> 

                        <i   class="el-icon-remove"  style="font-size:24px;cursor:pointer;margin-top:8px;margin-left:10px"  @click="RemoveLine(index)"></i>

              
        
                    </div>  


                </div>



                <div class='optionitem' style="font-size:14px;text-align:left;margin-top:10px;width:75%">(银行利息计算方式下，一般算头不算尾，是之前的默认方式。根据部分客户的需求，增加算头又算尾的方式。中间有还款的情况下，建议选择算头不算尾，两头都算会造成多计算重复天数利息。多次还款计算为非复利计算。)</div>
                <div class='optionitem' style="font-size:14px;text-align:left;margin-top:10px;width:75%;color:red">非会员每天可免费计算五次，超过次数每次需消耗0.25法币。会员免费。详情word下载仅限会员。</div>


                <!-- <div class='optionitem' >   
                    <div class="optionitem item_name" >填写利息({{ratio}})：</div>
                    <div style="width:70%;"> <el-input type='number' min=0 v-model="interest" placeholder="请输入利息（统一用小数表示）"></el-input> </div>
                        
                </div>  -->

                <div style="width:90%">
                    <!-- <span  class="guide" @click="CheckDemo">查看word报告模板</span> -->
                    <a  style="margin-left:40px;text-decoration: underline; color: rgb(19, 109, 145);"  href="https://lawassist.oss-cn-hangzhou.aliyuncs.com/mix/lpr_template.png"  target='_blank'  class="guide">   
                        查看详情word模板
                    </a> 

                    <span  class="guide" @click="CheckDemo">查看案例模板</span>

                </div>  

       

                <div  class="history_button"   > 
                
                    <span style="font-size:14px;float:right">     {{today}} lpr利率:  一年期:{{today_lpr1}}%  五年期:{{today_lpr5}}%   </span>
          
                    <span style="font-size:14px;float:right">    当前法定受保护利率上限:  {{today_lpr1*4}}%  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;​  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;​   </span>
                </div>

                <!-- <div  class="history_button"  style="  margin-top:5px;"  > 
                    <span style="font-size:14px;float:right">    当前法定受保护利率上限:  {{today_lpr1*4}}%  </span>
                </div> -->
          

                <div class="history_button"  style="  margin-top:5px;" > 
                   
 
                    <div style="float:right">
                        <span>我的法币余额： {{ $store.state.accountInfo.coins }} </span>

                        <el-button type="info" style="margin-left:20px" @click="Go2Deposit">充值</el-button>
                    </div>
            
                </div>


                <div  style="margin-top:60px">
                    <!-- <button @click="alert('ok')" type="button">Click Me!</button>
                    <button type="button">Cancle!</button> -->
                 
                    <el-row v-if="isDemo==1"  >

                  
                        <el-button type="warning"  @click="Cancel_demo" style="margin-left: 50px; width:500px;height:60px;font-size:20px">结束案例查看</el-button>
                
                    </el-row>
                 
                  
                 
                    <el-row v-else>

                        <el-button @click="newcal" type="primary" style="min-width:120px">
                            计算 
                            <span v-if="$store.state.accountInfo.vip!=1">(免费额度：{{leftnum}})</span>
                        </el-button>
                        <el-button type="warning"  @click="reset" style="margin-left: 50px;min-width:120px">重置</el-button>
                
                    </el-row>
                </div>

       

        
                      


                <div class="result">
                    <h4>计算结果（利息模式：{{lpr_mode=='lpr1'? '一年期':'五年期' }}）：</h4>
                    <!-- <p v-cloak style="margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp;天数共计： {{ratio=='LPR'?result.totalDays:s3}} 日</p> -->
                    <p v-cloak style="margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp;初始本金： {{inputValue}} 元</p>
                    <p v-cloak style="margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp;天数共计： {{s3}} 日</p>
                    <p v-cloak style="margin-top:5px;" v-if="resArr.length>0" >&nbsp;&nbsp;&nbsp;&nbsp;利息合计： {{resArr[resArr.length-1].int_sum}}  </p>
                    <p v-cloak style="margin-top:5px;"  v-if="resArr.length>0">&nbsp;&nbsp;&nbsp;&nbsp;本息合计： {{resArr[resArr.length-1].sum}}  </p>
                    
                
                    <!-- <p v-if="ratio=='maxLPR'" v-cloak style="margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp; 利息共计： {{result.totalInt_1*4}}   元</p>
                    <p v-if="ratio=='maxLPR'" v-cloak style="margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp;本息共计： {{result2}}   元</p>

                    <p v-if="ratio!='maxLPR'" v-cloak style="margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp; 利息共计：  {{result.totalInt_1+'(lpr1)/'+result.totalInt_5+'(lpr5)'}}  元</p>
                    
                    <p v-if="ratio!='maxLPR'" v-cloak style="margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp; 1年期本息合计： {{  result_lpr1 }}    </p>
                    <p v-if="ratio!='maxLPR'" v-cloak style="margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp; 5年期本息合计： {{  result_lpr5 }}    </p> -->


                    <h4>详情<span style="color:red">(仅会员可见)</span>：</h4>
                    <div  v-for="(item,index) of resArr" v-bind:key="index"   class='resultbox' >   
                        <span  class='item_result' selectable decode="true"> 日期：{{index>0?  resArr[index-1].date :date[0]}}至 {{item.date}}   </span>
                        <span v-if="resArr.length>1"  class='item_result' selectable decode="true"> 当前计算本金：{{item.ini_capital}}    </span>
                        <span v-if="resArr.length>1 && item.amount>0"  class='item_result' selectable decode="true"> 本期还款金额：{{item.amount}}    </span>
                        <span   class='item_result' selectable decode="true">期间利息： {{ item.int }}  元</span>
                    
                        <span v-if="resArr.length>1  && item.amount>0"  class='item_result' selectable decode="true">还款后剩余利息： {{ item.int_sum }}  元</span>
               
                        <span   class='item_result' selectable decode="true">本息结余： {{ item.sum  }}   元</span>
                        <span v-if="resArr.length>1" class='item_result' selectable decode="true">天数： {{ item.result.totalDays }}  </span>
                        
                        <span class='item_result' selectable decode="true" v-if="ratio=='avgLPR'">{{lpr_mode=='lpr1'? 'LPR一年期平均值：'+item.result.avgLPR:  'LPR五年期平均值：'+item.result.avgLPR_5 }}   </span>

                        <span class='item_result' selectable decode="true"  > 利息算法：<span  style="color:red;"   >    </span>  </span>
                        <!-- v-if="$store.state.accountInfo.vip==1" -->
                        <span v-if="$store.state.accountInfo.vip==1 || isDemo==1 " class='item_result' selectable decode="true"   >{{lpr_mode=='lpr1'? item.result.algorithm_1 : item.result.algorithm_5 }}  </span>
                        <span v-else @click="beVip" style="text-align:center;  text-decoration: underline; color: rgb(19, 109, 145); cursor: pointer;padding-left:50px"> 会员可见，成为会员，还可下载详情文档</span>

                   
                    
                    </div>
                 

                    <!-- <h4>算法详情<span style="color:red">(仅会员可见)</span>：</h4>
                 
                    <div class="algorithm"    >
                        <div    v-if="$store.state.accountInfo.vip==1"> 
                            <span v-if="ratio=='lastLPR' || ratio=='firstLPR' || ratio=='avgLPR' "  class='item_result'   decode="true">
                                <p  class='item_result'        decode="true">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;一年期算法：{{result.algorithm_1}}   </p>

                                <p  class='item_result'   v-html="'&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;一年期算法解析：\n'+result.algorithm_1_explain"     decode="true">  </p>


                                <p  class='item_result'      decode="true">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;五年期算法：{{result.algorithm_5}} </p>
                                <p  class='item_result'   v-html="'&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;五年期算法解析：\n'+result.algorithm_5_explain"     decode="true">  </p>
                            </span>

                            <span  v-else-if="ratio=='maxLPR'"  class='item_result'   decode="true">
                                <p  class='item_result'       decode="true">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;法定利率上限算法：4*{{result.algorithm_1}}   </p>
                            </span>

                            <span v-if="ratio=='LPR'"  class='item_result'  decode="true">
                                <p  class='item_result'   >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;一年期算法： 
                                    <span v-for="(item,index) of  result.total_lpr"  :key='index'     > ({{item.lpr1+'%'}}/{{day_base}})*{{item.days}}*{{inputValue}} {{index==result.total_lpr.length-1? '':'+' }}   </span>
                                </p>
                                <p  class='item_result'   >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 五年期算法：  
                                    <span v-for="(item,index) of  result.total_lpr"  :key='index'   > ({{item.lpr5+'%'}}/{{day_base}})*{{item.days}}*{{inputValue}} {{index==result.total_lpr.length-1? '':'+' }}   </span>
                                </p>
                            </span>


                        </div>
                

                        
                    </div> -->



                    <p class='item_result' style='color:#000000 ' decode="true">&nbsp;&nbsp;&nbsp;&nbsp;备注：2019年8月19日之前按同期中国人民银行公布的贷款基准利率计付，2019年8月20日之后按同期全国银行间同业拆借中心公布的贷款市场报价利率（LPR）计付。跨越19年8月20日前后的，可以至老版基准利息计算器计算19年8月20日以前的部分，再和本计算器中的结果相加。</p>
                    <p class='item_result' style='color:#000000 ' decode="true">&nbsp;&nbsp;&nbsp;&nbsp;分段LPR：计算每个LPR阶段的利息</p>
                    <p class='item_result' style='color:#000000 ' decode="true">&nbsp;&nbsp;&nbsp;&nbsp;平均LPR：指持续期间LPR的平均值计算</p>
                    <p class='item_result' style='color:#000000 ' decode="true">&nbsp;&nbsp;&nbsp;&nbsp;截至月LPR：指以最后一个月的有效LPR值来计算</p>
                    <p class='item_result' style='color:#000000 ' decode="true">&nbsp;&nbsp;&nbsp;&nbsp;2019年8月19日之前的利息，请到基准利息计算器进行计算查询</p>
                    <div style="width:100%;display:flex;flex-direction:row;height:35px;line-height:35px">
                        <el-button type="primary" plain @click="bind_download"  >下载详情文档(VIP专享)</el-button>
                        <!-- <div @click="check_word_template" style="margin-left:40px;text-decoration: underline; color: rgb(19, 109, 145);">查看详情word模板</div> -->
                        <!-- <a  style="margin-left:40px;text-decoration: underline; color: rgb(19, 109, 145);"  href="https://lawassist.oss-cn-hangzhou.aliyuncs.com/mix/lpr_template.png"  target='_blank'  class="guide">   
                            查看详情word模板
                        </a>  --> 
                    </div>
                  
                </div>


                <div  v-for="(item,index) of resArr" v-bind:key="index"  style="width:90%;margin-left:auto;margin-right:auto"> 
                    <el-table
                        v-if="ratio!='LPR'"
                        :data="item.result.total_lpr"
                        stripe
                        style="width: 100%;margin-bottom:15px">
                        <el-table-column
                        prop="uploadDate"
                        label="央行LPR更新日期"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="lpr_1"
                        label="LPR一年期(单位：%)"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="lpr_5"
                        label="LPR五年期(单位：%)">
                        </el-table-column>
    
                    </el-table>

                    <el-table
                        v-else
                        :data="item.result.total_lpr"
                        stripe
                        style="width: 100%"
                       
                        >
                        <!-- show-summary
                        :summary-method="getSummaries -->
                        <el-table-column
                        prop="uploadDate"
                        label="央行LPR更新日期"
                        width="180">
                        </el-table-column>

                        <el-table-column
                        prop="lpr_1"
                        label="LPR一年期利率(单位：%)"
                        width="120">
                        </el-table-column>

                        <el-table-column
                        prop="lpr_5"
                        label="LPR五年期利率(单位：%)"
                        width="120">
                        </el-table-column>

                        <el-table-column
                        prop="startDate"
                        label="开始日期"
                        width="220"
                        align="center">
                        </el-table-column>

                        
                        <el-table-column
                        prop="endDate"
                        label="截至日期"
                        width="220"
                        align="center">
                        </el-table-column>

                        <el-table-column
                        prop="days"
                        label="天数"
                        width="100">
                        </el-table-column>

                        <el-table-column
                        prop="int1"
                        label="利息(lpr1)"
                        width="120">
                        </el-table-column>

                        <el-table-column
                        prop="int5"
                        label="利息(lpr5)"
                        width="120">
                        </el-table-column>
    
                    </el-table>



                </div>

              
               
               
                <img src="@/assets/images/ads/lpr.jpg" alt="lpr利率计算器,lpr利息计算,lpr计算器"  class="hidden_img" style="border: 2px solid #dedede;" >
 
                <!-- <div class="result"  >
                    <p>产品介绍：</p>
                    <img src="@/assets/images/ads/lpr.jpg" alt="lpr利息计算器,lpr司法利率计算"  class="hidden_img" style="border: 2px solid #dedede;" >
 

                </div>   -->

                <div class="result"  >
                    <p>律师云助理小程序：</p>
         
                    <img object-fit='scale-down' src="@/assets/images/wecode.jpg" alt="lpr利率计算小程序码，更多律师工具欢迎体验"  style="max-width:90%;,ax-height:500px" >

                </div> 
                        

            </div>   




          

        </div>




</template>

<script>

// import XLSX from "@/assets/js/excel/xlsx.full.min.js";
// import FileSaver from "file-saver";
// import FileSaver from '@/assets/js/html2word/FileSaver.js'
// import Blob  from '@/assets/js/excel/Blob.js'
// import Export2Excel  from '@/assets/js/excel/Export2Excel.js'


// exportExcel() {
//   require.ensure([], () => {
//     const { export_json_to_excel } = require('../excel/Export2Excel');
//     const tHeader = ['序号', '昵称', '姓名'];
//     // 上面设置Excel的表格第一行的标题
//     const filterVal = ['index', 'nickName', 'name'];
//     // 上面的index、nickName、name是tableData里对象的属性
//     const list = this.tableData;  //把data里的tableData存到list
//     const data = this.formatJson(filterVal, list);
//     export_json_to_excel(tHeader, data, '列表excel');
//   })
// },

// formatJson(filterVal, jsonData) {
//   return jsonData.map(v => filterVal.map(j => v[j]))
// }


var filters = {
    toFix: function (value) {
        return value.toFixed(2)//此处2为保留两位小数
    }
} 

function guid2() {
    function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return (S4() + S4()  + S4()  + S4() +  S4() +  S4() + S4() + S4());
}

function isphone() {
	var sUserAgent = navigator.userAgent.toLowerCase();
	var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
	var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
	var bIsMidp = sUserAgent.match(/midp/i) == "midp";
	var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
	var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
	var bIsAndroid = sUserAgent.match(/android/i) == "android";
	var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
	var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
	if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid
			|| bIsCE || bIsWM) {
		return true
	} else {
		return false
	}
}

function DateDiff(sDate1, sDate2) {    //sDate1和sDate2是2002-12-18格式  
  var aDate, oDate1, oDate2, iDays
  aDate = sDate1.split("-")
  oDate1 = new Date(aDate[1] + '/' + aDate[2] + '/' + aDate[0])    //转换为12-18-2002格式  
  aDate = sDate2.split("-")
  oDate2 = new Date(aDate[1] + '/' + aDate[2] + '/' + aDate[0])
  iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24) 
     //把相差的毫秒数转换为天数  
  return iDays
}



import consult from '@/components/ads/consult.vue' 
import { IncUseNumber ,SetMinHeight } from '@/assets/js/cal/cal';  

export default {
        name: 'interest3',
        metaInfo: {
            title: 'LPR利息计算器|LPR利率计算器|司法利率计算器', // set a title
            meta: [{                 // set meta
                name: 'keywords',
                content: 'lpr计算器,LPR利率计算,律师咨询,lpr司法计算,银行间同业拆借贷款利息'
            }],
      
        },
		props: {
            // isPhone: Boolean
        },
        components: { 
            consult
        },
        mounted() {
            IncUseNumber('interest3')
            SetMinHeight()
            this.isPhone=isphone()
            this.getTodayLpr()
      
            this.refresh_coins()

            this.check_lpr_record()

        },
        data() {
			return { 
                inputValue:'',
                date:['',''],
                ratio:'LPR',
                s3:'',
                max_mode:'max2',
                result:{totalInt_1:0,totalInt_5:0},
                result1:'',
                result2:'',
                result_lpr1:'',
                result_lpr5:'',
                // interest:'',
                day_base:'360',
                tableData:[],     
                guid:'',    
                days_mode:'mode_d1',
                today: new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate(),
                leftnum:5,
                
                screenWidth:window.innerWidth,
                screenHeight:window.innerHeight,
                isPhone:false,
                algorithm:[],
                lpr_mode:'lpr1',
                param:{
                    cond:[
                        // {  amount:0 ,date:  new Date().getFullYear() + "/" + (new Date().getMonth() + 1) + "/" + new Date().getDate()  } //s1: 'plus'  , , kind:'borrow' 
                    ],   
                },
                resArr:[],
                isMuti:'no',
                today_lpr1:'',
                today_lpr5:'',

                isDemo: 0,
                float_step:0,
            }
        },
        methods:{
            reset(){
                this.inputValue=0
                this.param.cond=[]
                this.resArr=[]
                this.s3=''

            },
            CheckDemo(){
                var that=this 
            
                let param={
                    cond:[
                        {amount: "3000", date: "2022/01/15", timestamp: 1642176000000},
                        {amount: "5000", date: "2022/04/20", timestamp: 1650384000000}
                    ],   


                }
                this.param=param

                let result={"data":[{"amount":"3000","capital":7160.04,"date":"2022/01/15","ini_capital":10000,"int":160.04,"int_left":0,"int_sum":0,"param":{"days_mode":"mode_d1","endDate":"2022/07/15","ini_amount":10000,"lpr_mode":"lpr1","startDate":"2021/08/18","type":"LPR","year":"360"},"result":{"algorithm_1":"","algorithm_5":"","endDate":"2022/01/15","lpr_mode":"lpr1","startDate":"2021/08/18","totalDays":150,"totalInt_1":160.04,"totalInt_5":193.76,"total_lpr":[{"days":2,"endDate":"2021-08-19","int1":"2.14","int5":"2.58","lpr_1":"3.85","lpr_5":"4.65","startDate":"2021/08/18","uploadDate":"2021-07-20"},{"days":33,"endDate":"2021-09-21","int1":"35.29","int5":"42.63","lpr_1":"3.85","lpr_5":"4.65","startDate":"2021-08-20","uploadDate":"2021-08-20"},{"days":28,"endDate":"2021-10-19","int1":"29.94","int5":"36.17","lpr_1":"3.85","lpr_5":"4.65","startDate":"2021-09-22","uploadDate":"2021-09-22"},{"days":33,"endDate":"2021-11-21","int1":"35.29","int5":"42.63","lpr_1":"3.85","lpr_5":"4.65","startDate":"2021-10-20","uploadDate":"2021-10-20"},{"days":28,"endDate":"2021-12-19","int1":"29.94","int5":"36.17","lpr_1":"3.85","lpr_5":"4.65","startDate":"2021-11-22","uploadDate":"2021-11-22"},{"days":26,"endDate":"2022/01/15","int1":"27.44","int5":"33.58","lpr_1":"3.80","lpr_5":"4.65","startDate":"2021-12-20","uploadDate":"2021-12-20"}]},"sum":"7160.04","timestamp":1642176000000},{"amount":"5000","capital":2230.06,"date":"2022/04/20","ini_capital":7160.04,"int":70.02,"int_left":0,"int_sum":0,"result":{"algorithm_1":"","algorithm_5":"","endDate":"2022/04/20","lpr_mode":"lpr1","startDate":"2022/01/15","totalDays":95,"totalInt_1":70.02,"totalInt_5":86.97,"total_lpr":[{"days":5,"endDate":"2022-01-19","int1":"3.78","int5":"4.62","lpr_1":"3.80","lpr_5":"4.65","startDate":"2022/01/15","uploadDate":"2021-12-20"},{"days":32,"endDate":"2022-02-20","int1":"23.55","int5":"29.28","lpr_1":"3.70","lpr_5":"4.60","startDate":"2022-01-20","uploadDate":"2022-01-20"},{"days":28,"endDate":"2022-03-20","int1":"20.61","int5":"25.62","lpr_1":"3.70","lpr_5":"4.60","startDate":"2022-02-21","uploadDate":"2022-02-21"},{"days":30,"endDate":"2022-04-19","int1":"22.08","int5":"27.45","lpr_1":"3.70","lpr_5":"4.60","startDate":"2022-03-21","uploadDate":"2022-03-21"},{"days":0,"endDate":"2022/04/20","int1":"0.00","int5":"0.00","lpr_1":"3.70","lpr_5":"4.60","startDate":"2022-04-20","uploadDate":"2022-04-20"}]},"sum":"2230.06","timestamp":1650384000000},{"amount":0,"capital":2230.06,"date":"2022/07/15","ini_capital":2230.06,"int":19.72,"int_left":19.72,"int_sum":19.72,"result":{"algorithm_1":"","algorithm_5":"","endDate":"2022/07/15","lpr_mode":"lpr1","startDate":"2022/04/20","totalDays":86,"totalInt_1":19.72,"totalInt_5":23.99,"total_lpr":[{"days":30,"endDate":"2022-05-19","int1":"6.88","int5":"8.55","lpr_1":"3.70","lpr_5":"4.60","startDate":"2022-04-20","uploadDate":"2022-04-20"},{"days":56,"endDate":"2022/07/15","int1":"12.84","int5":"15.44","lpr_1":"3.70","lpr_5":"4.45","startDate":"2022-05-20","uploadDate":"2022-05-20"}]},"sum":"2249.78"}],"leftnum":5,"overNum":0,"status":"ok"}


                let resArr=result.data 
                this.inputValue=10000
                that.isDemo=1
                that.ratio='LPR'
                this.date=['2021-08-18','2022-07-15']
                this.isMuti='yes'
                this.s3=331
                this.day_base='360'
                this.days_mode='mode_d1',
                that.resArr=resArr
                    //     whattodo:'LPRcal',
                    // startDate: this.date[0],
                    // endDate: this.date[1],
                    // type: this.ratio,
                    // amount: filters.toFix(parseFloat(this.inputValue)), 
                    // year: this.day_base,
                    // days:this.s3,
                    // days_mode:this.days_mode,
                    // max_mode:this.max_mode,
                    // lpr_mode:that.lpr_mode,
                    // cond:cond,
                    // isMuti:that.isMuti,


                if(that.ratio=='LPR'){
                    let a1='',a5='',len,lpr
                    for(let p of resArr){
                        len=p.result.total_lpr.length
                        lpr=p.result.total_lpr
                        for(let i=0;i<len;i++){
                            if(i!=len-1){
                            a1=a1+"("+lpr[i].lpr_1+'%/'+that.day_base+")*"+lpr[i].days+"*"+ p.capital+'+'
                            a5=a5+"("+lpr[i].lpr_5+'%/'+that.day_base+")*"+lpr[i].days+"*"+  p.capital+'+'
                            }else{
                            a1=a1+"("+lpr[i].lpr_1+'%/'+that.day_base+")*"+lpr[i].days+"*"+  p.capital
                            a5=a5+"("+lpr[i].lpr_5+'%/'+that.day_base+")*"+lpr[i].days+"*"+  p.capital
                            }
                            
                        }
                        p.result.algorithm_1=a1
                        p.result.algorithm_5=a5
                        if(that.lpr_mode=='lpr1'){
                            p.result.algorithm=a1
                        }else{
                            p.result.algorithm=a5

                        }
        
                    }
                }

            },

            AddLine(){
                var that=this 
                if(this.$store.state.accountInfo.vip!=1){
                    that.$message({
                        type: 'info',
                        message:'该功能为会员功能',
                        showClose: true,
                        duration:3000,
                    });
                    return
                }
                if(this.param.cond.length<100){

                    let obj=that.param.cond
                    let date= new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate()
                    let t= { amount:0 ,date:  date , }  // kind:'back'   s1: 'plus'  ,
                    this.param.cond.push(t)
                    // obj.push(t)
                    // that.setData({
                    //     'param.cond':obj
                    // })
                }else{
                    that.$message({
                        type: 'info',
                        message:'超过支持上限',
                        showClose: true,
                        duration:3000,
                    });
                  
                }
            },

            RemoveLine(index){
            
                // let index=e.currentTarget.dataset.ind
                if(this.param.cond.length>=1){
                    // console.log("lenth:",this.data.param.cond.length)
                    let obj=this.param.cond
                    
                    obj.splice(index,1)
                    this.param.cond=obj
                    // this.setData({
                    //     'param.cond':obj
                    // })
                }

            },

            beVip(){
                window.open('https://www.lawtip.cn/bevip')
            },

            newcal(){
                if(!this.date[0] || !this.date[1] ){
                    alert('起止日期记得选择哦');
                    return
                }

                var that = this;
                this.isDemo=0
                var t = that.inputValue; //输入的金额

                var tmp1=Date.parse(this.date[0])
                var tmp2=Date.parse(this.date[1])
                var cond = JSON.parse(JSON.stringify(this.param.cond));
 

                if(tmp1>tmp2){
                    alert('开始日期要小于截止日期');
                    return
                }
                this.s3= DateDiff(this.date[0], this.date[1]);
                if(this.days_mode=='mode_d2'){
                    this.s3++
                }

                // var s1 = that.data.date1
                // var s2 = that.data.date2
                // var gap = DateDiff(s1, s2);

                // if(this.data.days_mode=='mode_d2'){
                //     gap++
                // }

                for(let p of cond){
            
                    p.date=p.date.replace(/\//g, "-")
                    p.timestamp=Date.parse(p.date)

                    if( (!p.amount || p.amount==0) && p.timestamp!=Date.parse(this.date[1])  ){
            
                        that.$message({
                            type: 'info',
                            message:'还款金额不能为0',
                            showClose: true,
                            duration:3000,
                        });
                        return

                        
                    }

                    if(tmp1>p.timestamp){
    
                        that.$message({
                            type: 'info',
                            message: '开始日期要小于还款日期',
                            showClose: true,
                            duration:3000,
                        });
                        return
                    }

                    if(tmp2<p.timestamp){

                        that.$message({
                            type: 'info',
                            message: '还款日期要小于截止日期',
                            showClose: true,
                            duration:3000,
                        });
                        return
                    }

                }

                cond.sort((x,y)=>{
                    return x.timestamp-y.timestamp

                })

                if (cond.length>0){
                   this.isMuti='yes'
            
                    if(  Date.parse(cond[cond.length-1].date)<Date.parse(this.date[1])   ){
                        cond.push({  amount:0 ,date: this.date[1].replace(/\//g, "-")  })
                    }

                }else{
                  this.isMuti='no'
                  cond= [{  amount:0 ,date: this.date[1]  }]  
                }

                // this.isMuti=isMuti

                // var s1_timestamp=Date.parse(s1)/1000
                if(tmp1/1000<1566230400){  
                    // 对lpr计算器和人损计算器做了小量更新
                    // console.log("this.data.method:",this.data.method)
                    if(this.ratio!='maxLPR' || this.max_mode!='max2'){
                        this.ratio='maxLPR'
                        this.max_mode='max2'
                        that.$message({
                            showClose: true,
                            message: '19年8月20日之前仅支持取截止日期的法定最高模式',
              
                        });
                        
                        // this.setData({
                        //     method:'maxLPR',
                        //     max_mode:'max2',
                        //     error:'19年8月20日之前仅支持取截止日期的法定最高模式'
                        // })

                    

                    }
                }

                this.bindcalculate2(cond)



            },
            bindcalculate2(cond){
                var that=this
                var data= { 
                    whattodo:'LPRcal',
                    startDate: this.date[0],
                    endDate: this.date[1],
                    type: this.ratio,
                    amount:filters.toFix(parseFloat(this.inputValue)), // parseFloat(this.inputValue), // filters.toFix(parseFloat(this.inputValue)), 
                    year: this.day_base,
                    days:this.s3,
                    days_mode:this.days_mode,
                    max_mode:this.max_mode,
                    lpr_mode:that.lpr_mode,
                    float_step:this.float_step/100,
                    cond:cond,
                    isMuti:that.isMuti,
                    
                }
                // this.axios.post( 'https://11law.lawtip.cn/php/LPRcal5.php'  ,data  //'https://11law.lawtip.cn/php/LPRcal5.php   this.$root.rootUrl+'pay' 
                this.axios.post( this.$root.rootUrl+'pay' ,data  //'https://11law.lawtip.cn/php/LPRcal5.php   this.$root.rootUrl+'pay' 
                ).then(function (res) {
                    window.console.log(res)
                    
                        if(res.status==200){
                        let result=res.data
                        let resArr=result.data 
                        if(result.status=='ok'){
                            // that.s3=gap 
                            that.result=result
                            that.guid=guid2()

                            if(that.$store.state.accountInfo.vip!=1){
                                let title
                                if(that.leftnum>result.leftnum){
                                    title='成功,消耗一次免费额度'
                                }else{
                                    title='计算成功'
                                }


                                if(that.leftnum==1 && result.leftnum==0){
                                    title='计算成功,今日免费额度已经用完'
                                }

                                that.$message({
                                    showClose: true,
                                    message: title,
                    
                                });

                                that.leftnum=result.leftnum
                                that.refresh_coins()
                            }
            
                            if(that.ratio=='LPR'){
                                let float_str='',deviation

                                if(that.float_step>0){
                                    deviation=1+that.float_step/100;
                                    float_str="*"+deviation;
                                    
                                }else if(that.float_step<0){
                                    deviation=1+that.float_step/100;
                                    float_str="*"+deviation;
                                    
                                }else{
                                    deviation=1;
                                    float_str='';
                                }
                                
                                for(let p of resArr){
                                    let a1='',a5='',len,lpr
                                    len=p.result.total_lpr.length
                                    lpr=p.result.total_lpr
                                    for(let i=0;i<len;i++){
                                        if(i!=len-1){
                                        a1=a1+"("+lpr[i].lpr_1+'%'+float_str+'÷'+that.day_base+")*"+lpr[i].days+"*"+ p.ini_capital+'+'
                                        a5=a5+"("+lpr[i].lpr_5+'%'+float_str+'÷'  +that.day_base+")*"+lpr[i].days+"*"+  p.ini_capital+'+'
                                        }else{
                                        a1=a1+"("+lpr[i].lpr_1+'%'+float_str+'÷' +that.day_base+")*"+lpr[i].days+"*"+  p.ini_capital
                                        a5=a5+"("+lpr[i].lpr_5+'%'+float_str+'÷' +that.day_base+")*"+lpr[i].days+"*"+  p.ini_capital
                                        }
                                        
                                    }
                                    p.result.algorithm_1=a1
                                    p.result.algorithm_5=a5
                                    if(that.lpr_mode=='lpr1'){
                                        p.result.algorithm=a1
                                    }else{
                                        p.result.algorithm=a5

                                    }
                    
                                }
                            }

                            that.resArr=resArr
                        }else if(result.status=='fail'){
                            that.$message.error(result.failMsg);
                        }else if(result.status=='badgate'){
                            that.$message.error('请先登录');
                        }

                    
                       
                    
                        

                    }
                   
    
                    
                }).catch(function (error) {
                    window.console.log(error);
                    
                });



    

            },

        bindcalculate: function () {
         
            // if(!this.date[0] || !this.date[1] ){
            //     alert('日期记得选择哦');
            //     return
            // }


            console.log('this.date[0]:',this.date[0])

            let d1=new Date(this.date[0])

            if(d1<new Date('2019-08-20') ){
                
                if(this.ratio!='maxLPR'){ 
                    this.ratio='maxLPR'
                    alert('起始日期请如小于2019-08-20，则只支持法定最高模式');
                }
                this.max_mode='max2'

               
                // return
            }
         
          
            // var t =this.inputValue;
            // var xi =this.interest;
            window.console.log(this.date);
            var s1=new Date(this.date[0]);
            var s2=new Date(this.date[1]);

            if(s1>s2){
                alert('开始日期不能大于截止日期哦~');
                return
            }


            this.s3=(s2-s1)/86400000;

            if(this.days_mode=='mode_d2'){
                this.s3++
            }

            // this.s3=(this.date[1]-this.date[0]);
            window.console.log(s1);   
            window.console.log(s2);   
            window.console.log(this.s3);     

            // var a0, a1, a2, a3, a4, time;
  
            // var  sum;
            var that=this
            this.axios.get('https://11law.lawtip.cn/php/LPRcal4.php', {  //https://11law.lawtip.cn/php/LPRcal.php
                params: {
                    whattodo:'LPRcal',
                    startDate: this.date[0],
                    endDate: this.date[1],
                    type: this.ratio=='maxLPR'? 'lastLPR':this.ratio,
                    amount: filters.toFix(parseFloat(this.inputValue)),
                    year: this.day_base,
                    days:this.s3,
                    days_mode:this.days_mode,
                    max_mode:this.max_mode
                }
            })
            .then(function (response) {
                window.console.log(response);
                if(response.status==200){
                    that.result=response.data
                    that.result1=response.data.interest
                    that.result2=parseFloat(response.data.interest)+parseFloat(filters.toFix(parseFloat(that.inputValue)))
                    that.tableData=response.data.total_lpr
                    that.guid=guid2()
        
                    if(that.ratio=='LPR'){
                        for (let i in that.tableData){
                            that.tableData['duration']=that.tableData[i]['startDate']+" TO "+that.tableData[i]['endDate']
                        }

                    }
                    if(that.ratio!='maxLPR'){
                        let t=filters.toFix(parseFloat(that.inputValue))
                        that.result_lpr1=parseFloat(t) + parseFloat(that.result.totalInt_1)
                        that.result_lpr5=parseFloat(t) + parseFloat(that.result.totalInt_5)
                    }


                    if(that.ratio=='lastLPR'|| that.ratio=='firstLPR'|| that.ratio=='avgLPR'   ){
                        // that.data.algorithm={ algorithm_1:that.data.result.algorithm_1,algorithm_5: that.data.result.algorithm_5 }
                    that.algorithm=[{ 'lpr一年期利息算法':that.result.algorithm_1, 'lpr五年期利息算法': that.result.algorithm_5 }]
                    }else if(that.ratio=='maxLPR'){
            
                        that.algorithm=[{'lpr一年期利息算法': that.result.algorithm_1 +'*4'  }]
                    }else if(that.ratio=='LPR'){
                        let a1='',a5=''
                        let len=that.result.total_lpr.length
                        let lpr=that.result.total_lpr
                        for(let i=0;i<len;i++){
                            if(i!=len-1){
                                a1=a1+"("+lpr[i].lpr1+'%/'+that.day_base+")*"+lpr[i].days+"*"+ that.inputValue+'+'
                                a5=a5+"("+lpr[i].lpr5+'%/'+that.day_base+")*"+lpr[i].days+"*"+ that.inputValue+'+'
                            }else{
                                a1=a1+"("+lpr[i].lpr1+'%/'+that.day_base+")*"+lpr[i].days+"*"+ that.inputValue
                                a5=a5+"("+lpr[i].lpr5+'%/'+that.day_base+")*"+lpr[i].days+"*"+ that.inputValue
                            }
                        }
                    
                        that.algorithm=[{ 'lpr一年期利息算法':a1,  'lpr五年期利息算法':a5 }]
                    }

                    // algorithm
                   
                    

                }
            })
            .catch(function (error) {
                window.console.log(error);
            });

            // wx.request({
            //     url: 'https://11law.lawtip.cn/php/LPRcal.php', 
            //     data: {
            //         startDate: s1.replace(/\//g, "-"),  //.replace(/-/g,""),
            //         endDate: s2.replace(/\//g, "-"),   //.replace(/-/g, ""),
            //         whattodo:'LPRcal',
            //         type: that.data.method,
            //         amount: filters.toFix(parseFloat(t)),
            //         year: that.data.method_year,
            //         days:gap
            //     },
            //     header: {
            //     'content-type': 'application/json' // 默认值
            //     },
            //     success(res) {
            //     console.log(res.data)
            //     let result=res.data
            //     that.setData({
            //         days_gap: gap,
            //         result1: result.interest,
            //         result2: parseFloat(t) + parseFloat(result.interest),
            //         result: result
            //     })
            //     }
            // })


        
       

        
    
 
            // this.result1=amount1;
            // this.result2=amount2;
        




        },

        Turn2Guide(){

        },

        check_word_template(){

        },

        check_lpr_record(){
            var that=this 
            var data={
                whattodo:'check_lpr_left', 
            }
            this.axios.post( this.$root.rootUrl+'mini_app' ,data
            ).then(function (res) {
                var result=res.data
                window.console.log(res)
                if(result.status=='badgate'){
                    that.$message({
                        message: '请先登录哦',
                        type: 'warning'
                    });

                }else if(result.status=='ok'){
                    that.leftnum=result.data 
                   
                }
                // else if(result.status=='fail'){
                //     that.$message.error(result.failMsg);
                // }
            
            
                
            }).catch(function (error) {
                window.console.log(error);
             
            });

        },

        Cancel_demo(){

            this.isDemo=0
            this.reset()
        },

        getTodayLpr(){
            var that=this 
            var   date1= '2021/08/20'
            var date2= new Date().getFullYear() + "/" + (new Date().getMonth() + 1) + "/" + new Date().getDate()  //'2019/08/21',
            this.axios.get('https://11law.lawtip.cn/php/LPRcal4.php',{
                params: {
                    startDate: date1.replace(/\//g, "-"),
                    endDate:  date2.replace(/\//g, "-"),
                    whattodo:'LPRcal',
                    type: 'avgLPR',
                    amount: 0,
                    year: 360,
                    days:0
                }
            }).then(function (res) {
              
                window.console.log(res)
                if(res.status==200){
                    console.log('------------------------')
                    let result=res.data
                    that.today_lpr1=result.total_lpr[0].lpr_1
                    that.today_lpr5=result.total_lpr[0].lpr_5
                

                
                }else{
               
                    that.$message.error('网络或服务器故障未获取今日lpr，请刷新' );
                }
            
            
                
            }).catch(function (error) {
                window.console.log(error);
             
            });


        },


        bind_download(){
            // let tableData=this.tableData
            var that=this
            if(!this.guid){
                this.$message.error('需先计算得出有效结果');
                return
            }

            var data= { 
                whattodo: "download_lpr_excel3",
                // tableData:  that.result ,// {"total_lpr":this.tableData} ,
                pre_filename:this.guid,
                // algorithm:this.algorithm || []
                tableData:this.resArr,
             
            }
 
            

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let url= this.$root.rootUrl+'mini_app_vip'
            this.axios.post(url,data
            ).then(function (res) {
                var result=res.data
                window.console.log(res)
                if(result.status=='badgate'){
                    that.$message({
                        message: '请先登录哦',
                        type: 'warning'
                    });

                }else if(result.status=='ok'){
                    that.DownLoad(result.link)
                }else if(result.status=='fail'){
                    that.$message.error(result.failMsg);
                }
                loading.close();
            
                
            }).catch(function (error) {
                window.console.log(error);
                loading.close();
            });


        },

        refresh_coins() {  
            var that=this

			// console.log("this.$store.state.userInfo.userId:",this.$store.state.userInfo.userId)

			var datas= { 
				// userid: this.$store.state.userInfo.userId,
				// userid:that.$root.userInfo.userId,
				whattodo:'getCoins',
			}
			this.axios.post( this.$root.rootUrl+'pay',datas
			).then(function (res) {
				// window.console.log(res)
				if(res.status==200){
					var result=res.data
					// window.console.log('result:',result,'result.status:',result.status)
					if (result.status=='ok'){
					 
                        that.$root.accountInfo.coins=result.coins
                        console.log('============')
                        if(result.coins<that.myCoins){
                            
                            that.$message(  '消耗'+ ( that.myCoins-result.coins) +'法币' );
                        }

						that.$store.commit('SetNewCoins',result.coins)
                        that.myCoins=result.coins
					} 
					else if (result.status=='fail'){
						// that.$message('获取余额失败，请稍后再试');

						if(that.$store.state.islogin){
							that.$message('获取余额失败，请稍后再试');

						}
						
					} 

					// if(result.status=='badgate'){
					// 	that.$message({
					// 		message: '请先登录哦',
					// 		type: 'warning'
					// 	});
					// }else 

				}


				
			}).catch(function (error) {
				window.console.log(error);

			});


		},

        DownLoad(url){
                //    var that=this

            window.open(url, '_blank');

            // this.axios.get(url, {
            // })
            // .then(function (response) {
            //     window.console.log(response);
            //     if(response.status==200){
 
            //         window.console.log('ok')
            //     }
            // })
            // .catch(function (error) {
            //     window.console.log(error);
            // });
        },


        getSummaries(param) {
            var that=this
            const { columns, data } = param;
            const sums = [];
            window.console.log(data)
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if (index === 1 || index === 2 ||index === 3 ||index === 4   ) {
                    sums[index] = 'N/A';
                    return;
                }
                // if (index === 2) {
                //     sums[index] = 'N/A';
                //     return;
                // }
                if (index === 5) {
                    sums[index] =  that.result.totalDays;
                    return;
                }
                if (index === 6) {
                    sums[index] =  that.result.totalInt_1;
                    return;
                }
                if (index === 7) {
                    sums[index] =  that.result.totalInt_5;
                    return;
                }

                // const values = data.map(item => Number(item[column.property]));
                // if (!values.every(value => isNaN(value))) {
                //     sums[index] = values.reduce((prev, curr) => {
                //     const value = Number(curr);
                //     if (!isNaN(value)) {
                //         return prev + curr;
                //     } else {
                //         return prev;
                //     }
                //     }, 0);
                //     sums[index] += ' 元';
                // } else {
                //     sums[index] = 'N/A';
                // }
            });

            return sums;
        },

        Go2Deposit(){
 			this.$router.push({name:"deposit"})
		},

    // downloadMater() {
    //   const defaultCellStyle = {
    //     font: { name: "Verdana", sz: 11, color: "FF00FF88" },
    //     fill: { fgColor: { rgb: "FFFFAA00" } }
    //   };
    //   const wopts = {
    //     bookType: "xlsx",
    //     bookSST: false,
    //     type: "binary",
    //     defaultCellStyle: defaultCellStyle,
    //     showGridLines: false
    //   };
    //   const wb = { SheetNames: ["Sheet1"], Sheets: {}, Props: {} };
    //   let data = this.tableData;
    //   wb.Sheets["Sheet1"] = XLSX.utils.json_to_sheet(data);

    //   //创建二进制对象写入转换好的字节流
    //   let tmpDown = new Blob([this.s2ab(XLSX.write(wb, wopts))], {
    //     type: "application/octet-stream"
    //   });
    //   // 保存文件
    //   FileSaver.saveAs(tmpDown, "hello world.xls");
    // },
    // // 字符串转字符流
    // s2ab(s) {
    //   if (typeof ArrayBuffer !== "undefined") {
    //     let buf = new ArrayBuffer(s.length);
    //     let view = new Uint8Array(buf);
    //     for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
    //     return buf;
    //   } else {
    //     let buf = new Array(s.length);
    //     for (let j = 0; j != s.length; ++j) buf[j] = s.charCodeAt(j) & 0xff;
    //     return buf;
    //   }
    // }




        // exportExcel() {
        //     require.ensure([], () => {
        //         // const { export_json_to_excel } = require('../excel/Export2Excel');
        //         const { export_json_to_excel } = Export2Excel ;

                 
        //         const tHeader = ['序号', '昵称', '姓名'];
        //         // 上面设置Excel的表格第一行的标题
        //         const filterVal = ['index', 'nickName', 'name'];
        //         // 上面的index、nickName、name是tableData里对象的属性
        //         const list = this.tableData;  //把data里的tableData存到list
        //         const data = this.formatJson(filterVal, list);
        //         export_json_to_excel(tHeader, data, '列表excel');
        //     })
        // },

        // formatJson(filterVal, jsonData) {
        //     return jsonData.map(v => filterVal.map(j => v[j]))
        // }

      
    }






        

       


    }
</script>

<style>

.hidden_img{
    position: fixed;
    top:100px;
    z-index: -1;
}


.algorithm{
 border:1px dashed #3d2e2e; 
 padding:10px;
 min-height: 40px;

}






.plus_box{
    /* margin-left: auto;
    margin-right: auto; */
  border: 1px dashed #666666;
  width:70%;
  margin-top: 30px;
  
  /* display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: left; */

}



.refund_box{
  /* border: 1rpx solid #da2121; */
  width:100%;
  text-align: left;
  font-size:15px;
  margin-bottom: 6px;
  height: 30px;
  line-height: 30px;
  display: flex;
  flex-direction: row;

}

.newline{
    width:100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    /* border: 1px solid #2187da; */
    height: 40px;
    line-height: 40px;
    padding-bottom:10px;
  
}

.newline .item_name{
    width:20%;
    text-align: center;
    padding-left: 40px;
    /* border: 1px solid #2187da; */
}

.newline .item_detail{
    width: 30%;
}

.resultbox{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  border: 1px dashed #666666;
  width:100%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 20px;
}

.resultbox span{
    margin-top: 2px;
    margin-bottom: 2px;
}


.history_button{
  
  width:100%;
  margin-top:30px;
  height: 40px;
  line-height: 40px;
  /* height: 60px; */
  /* float: right; */
  /* border:3px solid #1d495c; */
  /* display: flex;
  flex-direction: row;
  align-items: center; */

}


.guide{
  /* font-size:22rpx; */
  float: right;
  /* padding-right: 20rpx; */
  text-decoration: underline;
  margin-right: 20px;
  color: rgb(19, 109, 145);
  cursor: pointer;
}
.el-date-editor--date{ 
    max-width: 200px; 
} 

</style>


<style   >
 
.el-date-editor.el-input {
    width: 100% ;
}
.el-date-editor--date {

    max-width: 100%;
}

</style>